/**
 * Identifies the trade aggregation transaction type.
 * tag: 2788
 * @readonly
 * @enum {number} (int)
 */
export enum TradeAggregationTransType {
  /** New */
  New = 0,
  /** Cancel */
  Cancel = 1,
  /** Replace */
  Replace = 2,
}
